<script setup>
/**
 * @deprecated OBSOLETO!!!!!!!!!!!!!!!!! usar Cuaderno.vue
 */
import { ref, onMounted } from 'vue';
import alumnos from '../../../api/cifra/alumnos';
import FilaAlumno from '../../../components/cuadernos/FilaAlumno.vue';

// Props
const props = defineProps({
  infoCuaderno: {
    type: Object,
    required: true,
  },
  // Estructura del tipo: { alumno: {...}, numero: 22 }
  infoAlumnos: {
    type: Array,
    required: true,
  },
});

// Estado reactivo
const indicadores = ref({});

// Métodos
const indicadoresAlumno = (alumno) => indicadores.value[alumno.id]?.indicadores || [];

function grupoParaAlumno(alumno) {
  const infoAlumno = props.infoAlumnos.find((ia) => ia.alumno.id === alumno.id);
  return infoAlumno?.grupo || props.infoCuaderno.grupo;
}

const linkTutorias = (alumno) => {
  const idGrupo = grupoParaAlumno(alumno)?.id;
  if (!idGrupo) {
    return null;
  }
  return `/tutorias/${alumno.id}/${idGrupo}%5E?cuaderno_id=${props.infoCuaderno.id}`;
};

// Ciclo de vida
onMounted(() => {
  alumnos.indicadores(
    props.infoAlumnos.map((ia) => ia.alumno.id),
    {
      params: {
        asignatura_id: props.infoCuaderno.horario.asignatura.id,
        evaluacion_id: props.infoCuaderno.evaluacion.id,
      },
    },
  ).then((result) => {
    indicadores.value = result.data;
  });
});
</script>

<template>
  <div class="max-height">
    <transition enter-active-class="animated fadeInDown">
      <div class="max-height">
        <slot name="header"></slot>
        <div class="cc-vertical-wrapper">
          <div class="cc-wrapper">
            <div class="cc-left">
              <div class="cc-row cc-headers">
                <slot name="header-alumnos"></slot>
              </div>
              <FilaAlumno
                v-for="info in infoAlumnos"
                :key="info.alumno.id"
                :alumno="info.alumno"
                :grupo="info.grupo"
                :numero="info.numero"
                :mostrar-numero="props.infoCuaderno.tipo !== 'desdoble'"
                :mostrar-grupo="props.infoCuaderno.tipo === 'desdoble'"
                :indicadores="indicadoresAlumno(info.alumno)"
                :link-alumno="linkTutorias(info.alumno)"
                class="cc-row"
              />
            </div>
            <div class="cc-middle">
              <div class="cc-table">
                <div class="cc-row cc-headers">
                  <slot name="row-headers"></slot>
                </div>
                <slot name="rows"></slot>
              </div>
            </div>
            <div class="cc-right">
            </div>
          </div>
        </div>
        <div class="form-actions p-t-sm">
          <slot name="bottom"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/components/cuadernos/constantes_cuaderno.scss';

.cc-vertical-wrapper {
  border: 2px solid $border-color;
  border-radius: 10px;
  background: rgb(221,221,221);
  background: linear-gradient(90deg, rgba(221,221,221,1) 0%, rgba(255,255,255,1) 100%);
}
.cc-row {
  background-color: white !important;
}
</style>
